import styled from 'styled-components';

export const MapWrapper = styled.div`
  width: 98%;
  max-width: 1098px;
  margin: 0px auto;
`;
